module.exports = __webpack_public_path__ + "media/images/cats/cat-pregnancy-calculator-feline-estrus.jpg";